export default __webpack_public_path__ + "images/8404131d0b5a63b8128b81f8ec9a1227-discover-icon.svg";